import React, { useEffect, useRef, useState } from "react";

/**
 * Multi-row free-text list: one entry per line (press Enter for a new row),
 * same UX as the Degree textarea. Stored/passed as an array of strings -
 * blank lines are dropped when committing up to the parent, but kept in the
 * textarea itself while typing so a fresh Enter press doesn't get eaten.
 */
export default function LineListInput({
    value = [],
    onChange,
    placeholder = "",
    rows = 3,
    className = "",
}) {
    const list = Array.isArray(value) ? value : [];
    const [text, setText] = useState(list.join("\n"));
    const lastCommitted = useRef(text);

    useEffect(() => {
        const incoming = list.join("\n");
        if (incoming !== lastCommitted.current) {
            setText(incoming);
            lastCommitted.current = incoming;
        }
    }, [value]);

    const handleChange = (e) => {
        const raw = e.target.value;
        setText(raw);
        const lines = raw.split("\n").map((l) => l.trim()).filter(Boolean);
        lastCommitted.current = lines.join("\n");
        onChange(lines);
    };

    return (
        <textarea
            value={text}
            onChange={handleChange}
            rows={rows}
            placeholder={placeholder}
            className={`w-full border border-secondary-200 rounded-lg px-3 py-2.5 text-sm text-secondary-800 bg-white focus:outline-none focus:ring-2 focus:ring-primary-300 transition-colors resize-y ${className}`}
        />
    );
}
